import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MedicalInformationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"medical_information"}/>
}
